// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"ada48d6d","69":"9181d57b","71":"75f385d6","788":"88ff703b","988":"db9d3ab8"}[chunkId] + ".chunk.js";
};